//import fetch from 'cross-fetch'

export const REQUEST_EVENTS = 'REQUEST_EVENTS'
export const RECEIVE_EVENTS = 'RECEIVE_EVENTS'
export const INVALIDATE_EVENTS = 'INVALIDATE_EVENTS'


export function invalidateEvents() {
  return {
    type: INVALIDATE_EVENTS
  }
}

function requestEvents() {
  return {
    type: REQUEST_EVENTS
  }
}

function receiveEvents(json) {
  return {
    type: RECEIVE_EVENTS,
    events: json,
    receivedAt: Date.now()
  }
}

function fetchEvents() {
  return dispatch => {
    dispatch(requestEvents())
    return fetch('//jeff.4zzz.org.au/api/birthday?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveEvents(json)))
  }
}

function shouldFetchEvents(state) {
  const events = state.events
  if (events.items.length === 0) {
    return true
  } else if (events.isFetching) {
    return false
  } else {
    return events.didInvalidate
  }
}

export function fetchEventsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchEvents(getState())) {
      return dispatch(fetchEvents())
    }
  }
}
